<template>
  <div>
    <VCardTitle class="dialog-header justify-start justify-md-center">
      {{ title }}
      <VBtn
        icon
        small
        absolute
        top
        right
        @click="$emit('close')"
      >
        <IconClose />
      </VBtn>
    </VCardTitle>
    <VDivider />
  </div>
</template>

<script>
import IconClose from './SvgIcons/Close.vue';

export default {
  name: 'DialogHeader',
  components: { IconClose },
  props: {
    title: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: 'success--text',
    },
  },
};
</script>

<style scoped lang="scss">
  .dialog-header {
    font-size: 1.5rem;
    line-height: 1.5;
    font-weight: 400;
    color: #212121;
    padding: 1.875rem 0 0.4375rem;
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .dialog-header {
      font-size: 1.25rem;
      min-height: 2.5rem;
      padding: 1.875rem 1.75rem 0.4375rem;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .dialog-header {
      padding: 1.5rem 1rem 0.4375rem;
    }
  }
</style>
